// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import { getDateGroup, formatRelativeTimeShort } from '@loa/theme';
import type { AdvisorNotification } from '../types/notification';
import type { NotificationData, NotificationPanelGroup } from '@loa/ui-components';

/**
 * Maps an AdvisorNotification to the generic NotificationData interface.
 */
function toNotificationData(notification: AdvisorNotification): NotificationData {
  return {
    id: notification.id,
    title: notification.title,
    message: notification.message,
    isRead: notification.isRead,
    createdAt: notification.createdAt,
    clickable: !!notification.referenceType,
  };
}

/**
 * Groups notifications by date and maps them to the NotificationPanel format.
 */
export function groupNotificationsByDate(
  notifications: AdvisorNotification[]
): NotificationPanelGroup[] {
  const groupMap = new Map<string, NotificationPanelGroup>();

  for (const notification of notifications) {
    const label = getDateGroup(notification.createdAt);
    const timeLabel = formatRelativeTimeShort(notification.createdAt);

    if (!groupMap.has(label)) {
      groupMap.set(label, { label, items: [] });
    }

    groupMap.get(label)!.items.push({
      notification: toNotificationData(notification),
      timeLabel,
    });
  }

  return Array.from(groupMap.values());
}
